import { LocalStorageKeys } from '../persist';

enum TokensEvents {
  TOKENS_UPDATED = 'tokens-updated',
  TOKENS_REMOVED = 'tokens-removed',
}

export class TokenPersistService {
  private readonly listeners: (
    | {
        event: TokensEvents.TOKENS_UPDATED;
        listener: (args: { accessToken: string; refreshToken: string }) => void;
      }
    | {
        event: TokensEvents.TOKENS_REMOVED;
        listener: ({
          accessToken,
          refreshToken,
        }: {
          accessToken: null;
          refreshToken: null;
        }) => void;
      }
  )[] = [];

  public onTokensUpdated(
    listener: (args: { accessToken: string; refreshToken: string }) => void
  ) {
    this.listeners.push({ event: TokensEvents.TOKENS_UPDATED, listener });

    return () => {
      const index = this.listeners.findIndex(
        (l) =>
          l.event === TokensEvents.TOKENS_UPDATED && l.listener === listener
      );

      if (index !== -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  public onTokensRemoved(
    listener: ({
      accessToken,
      refreshToken,
    }: {
      accessToken: null;
      refreshToken: null;
    }) => void
  ) {
    this.listeners.push({ event: TokensEvents.TOKENS_REMOVED, listener });

    return () => {
      const index = this.listeners.findIndex(
        (l) =>
          l.event === TokensEvents.TOKENS_REMOVED && l.listener === listener
      );

      if (index !== -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  public setTokens(accessToken: string, refreshToken: string) {
    localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, accessToken);
    localStorage.setItem(LocalStorageKeys.REFRESH_TOKEN, refreshToken);

    this.listeners.forEach((l) => {
      if (l.event === TokensEvents.TOKENS_UPDATED) {
        l.listener({ accessToken, refreshToken });
      }
    });
  }

  public getTokens() {
    return {
      accessToken: localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN),
      refreshToken: localStorage.getItem(LocalStorageKeys.REFRESH_TOKEN),
    };
  }

  public removeTokens() {
    localStorage.removeItem(LocalStorageKeys.ACCESS_TOKEN);
    localStorage.removeItem(LocalStorageKeys.REFRESH_TOKEN);

    this.listeners.forEach((l) => {
      if (l.event === TokensEvents.TOKENS_REMOVED) {
        l.listener({ accessToken: null, refreshToken: null });
      }
    });
  }
}
